<template>
  <v-card elevation="1">
    <v-card-title primary-title>
      Meal Planner
    </v-card-title>
    <v-row>
      <v-col md="4">
        <v-expansion-panels flat>
          <v-expansion-panel v-for="day in $moment.weekdays()" :key="day">
            <v-expansion-panel-header>{{ day }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col md="4">
        <v-card flat>
          <v-card-title primary-title>
            Shopping List
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="item in shopping" :key="item">
                {{ item }}
              </v-list-item>
              <v-list-item v-if="!shopping.length">No Items</v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat>
          <v-card-title primary-title>
            Notes
          </v-card-title>
          <v-card-text>
            <v-textarea
              v-model="notes"
              name="notes"
              outlined
              auto-grow
            ></v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "MealPlanner",
  data: () => ({
    shopping: [],
    notes: ""
  })
};
</script>

<style lang="scss" scoped></style>
